import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '../../views/Home.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'My Wordbook',
    },
  },
  {
    path: '/games/flash-cards',
    name: 'flashCards',
    component: () => import(/* webpackChunkName: "flashCards" */ '@/views/games/FlashCards.vue'),
  },
  {
    path: '/games/flash-cards/history/:history/:id',
    name: 'flashCardsReplay',
    component: () => import(/* webpackChunkName: "flashCards" */ '@/views/games/FlashCards.vue'),
  },
  {
    path: '/games/article-game/history/:history/:id',
    name: 'articleGameReplay',
    component: () => import(/* webpackChunkName: "flashCards" */ '@/views/games/ArticleGame.vue'),
  },
  {
    path: '/games/article-game',
    name: 'articleGame',
    component: () => import(/* webpackChunkName: "flashCards" */ '../../views/games/ArticleGame.vue'),
  },
  {
    path: '/games',
    name: 'games',
    component: () => import(/* webpackChunkName: "flashCards" */ '../../views/Games.vue'),
  },
  {
    path: '/games/:gameType/history',
    name: 'gameHistory',
    component: () => import(/* webpackChunkName: "gameHistory" */ '@/views/games/History.vue'),
  },
  {
    path: '/games/:gameType/history/:id',
    name: 'gameHistoryItem',
    component: () => import(/* webpackChunkName: "gameHistoryItem" */ '@/views/games/HistoryItem.vue'),
  },
  {
    path: '/games/anki',
    name: 'anki',
    component: () => import(/* webpackChunkName: "anki" */ '@/views/games/Anki.vue'),
  },
  {
    path: '/games/anki/history/:history/:id',
    name: 'ankiReplay',
    component: () => import(/* webpackChunkName: "anki" */ '@/views/games/Anki.vue'),
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/Settings.vue'),
  },
  {
    path: '/support',
    name: 'support',
    component: () => import(/* webpackChunkName: "support" */ '../../views/Support.vue'),
  },
  {
    path: '/words/new',
    name: 'newWord',
    component: () => import(/* webpackChunkName: "addOrEditWord" */ '../../views/AddOrEditWord.vue'),
  },
  {
    path: '/words/:id',
    name: 'editWord',
    component: () => import(/* webpackChunkName: "addOrEditWord" */ '../../views/AddOrEditWord.vue'),
  },
  {
    path: '/lists',
    name: 'lists',
    component: () => import(/* webpackChunkName: "addOrEditWord" */ '../../views/lists/Lists.vue'),
  },
  {
    path: '/lists/:id',
    name: 'editList',
    component: () => import(/* webpackChunkName: "addOrEditWord" */ '../../views/lists/AddOrEditList.vue'),
  },
  {
    path: '/lists/new',
    name: 'createList',
    component: () => import(/* webpackChunkName: "addOrEditWord" */ '../../views/lists/AddOrEditList.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to) => {
  document.title = (to.meta.title || 'My Wordbook' as any);
});

export default router;
